import { ReactNode } from 'react';
import '@/styles/tables.css';

interface BadgeProps {
  variant?: 'success' | 'error' | 'warning' | 'info' | 'neutral';
  children: ReactNode;
  className?: string;
}

export const Badge = ({ variant = 'neutral', children, className = '' }: BadgeProps) => {
  const variantClass = `status-badge-${variant}`;
  
  return (
    <span className={`status-badge ${variantClass} ${className}`}>
      {children}
    </span>
  );
};
